import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./base-modal.css";

const BaseModal = ({
    show,
    onClose,
    onBack,
    title,
    children,
    size = "md",
    footer = true,
    onSave,
    saveText = "Guardar",
    closeText = "Cancelar",
    showCancelButton = false,
    closable = true,
    backable = false,
    icon = null,
    className = "",
    disableSave = false,
}) => {
    let customFooter = null;
    const bodyChildren = [];

    React.Children.forEach(children, (child) => {
        if (child?.type === BaseModal.Footer) {
            customFooter = child;
        } else {
            bodyChildren.push(child);
        }
    });

    return (
        <Modal
            show={show}
            onHide={closable ? onClose : undefined}
            centered
            size={size}
            backdrop={closable ? true : "static"}
            keyboard={closable}
            scrollable
            className={`base-modal ${className}`}
        >
            {title && (
                <Modal.Header className="position-relative text-center justify-content-center flex-column gap-1">
                    {backable && (
                        <div className="position-absolute start-0 top-50 translate-middle-y">
                            <svg className="btn-close base-modal-close p-0 pb-5" type="button" onClick={onBack} aria-label="Back" xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 36 36" fill="none">
                                <path d="M25.5811 34.4648H9.88379C4.97749 34.4648 1 30.4874 1 25.5811V9.88379C1 4.97749 4.97749 1 9.88379 1H25.5811C30.4874 1 34.4648 4.97749 34.4648 9.88379V25.5811L34.4531 26.0381C34.223 30.5807 30.5807 34.223 26.0381 34.4531L25.5811 34.4648Z" stroke="#9DACBD" stroke-width="2"/>
                                <path d="M10.9998 17.6351C10.9998 17.0388 11.2273 16.4425 11.6823 15.9875L20.7119 6.95782C21.6218 6.04792 23.0971 6.04792 24.007 6.95782C24.9169 7.86772 24.9169 9.34307 24.007 10.253L16.6249 17.6351L24.007 25.0172C24.9169 25.9271 24.9169 27.4024 24.007 28.3124C23.0971 29.2223 21.6218 29.2223 20.7119 28.3124L11.6823 19.2827C11.2273 18.8277 10.9998 18.2313 10.9998 17.6351Z" fill="#9DACBD"/>
                            </svg>
                        </div>
                    )}

                    {icon && <div>{icon}</div>}

                    <span className="base-modal-title">{title}</span>

                    {closable && (
                        <div className="position-absolute end-0 top-50 translate-middle-y">
                            <svg
                                type="button"
                                className="btn-close base-modal-close p-0 pb-5"
                                aria-label="Close"
                                onClick={onClose}
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="27"
                                viewBox="0 0 26 27"
                                fill="none"
                            >
                                <path
                                    d="M13 1.5C19.2984 1.5 24.5 6.81872 24.5 13.5C24.5 20.1813 19.2984 25.5 13 25.5C6.70158 25.5 1.5 20.1813 1.5 13.5C1.5 6.81872 6.70158 1.5 13 1.5Z"
                                    stroke="#9DACBD"
                                    strokeWidth="3"
                                />
                                <path d="M8 8.5L17.5 18" stroke="#9DACBD" strokeWidth="2" strokeLinecap="round" />
                                <path d="M17.5 8.5L8 18" stroke="#9DACBD" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </div>
                    )}
                </Modal.Header>
            )}

            <Modal.Body>{bodyChildren}</Modal.Body>

            {footer && (
                customFooter ? (
                    <Modal.Footer className="d-flex align-items-center justify-content-center">
                        {customFooter.props.children}
                    </Modal.Footer>
                ) : (
                    <Modal.Footer className="d-flex align-items-center justify-content-center">
                        {showCancelButton && closable && (
                            <Button
                                className="base-modal-cancel-button"
                                variant="secondary"
                                onClick={onClose}
                            >
                                {closeText}
                            </Button>
                        )}
                        {onSave && (
                            <Button
                                className="base-modal-done-button"
                                variant="primary"
                                onClick={onSave}
                                disabled={disableSave}
                            >
                                {saveText}
                            </Button>
                        )}
                    </Modal.Footer>
                )
            )}
        </Modal>
    );
};

BaseModal.Footer = ({ children }) => children;

export default BaseModal;
